import { render, staticRenderFns } from "./Formula.vue?vue&type=template&id=5fff6094&scoped=true&"
import script from "./Formula.vue?vue&type=script&lang=js&"
export * from "./Formula.vue?vue&type=script&lang=js&"
import style0 from "./Formula.vue?vue&type=style&index=0&id=5fff6094&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fff6094",
  null
  
)

export default component.exports